import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { util } from '../../../util'

/**
 *
 * @param id
 * @param onChange
 * @param value
 * @param checked
 * @param label
 * @param name
 * @returns {*}
 * @constructor
 */
const Radio = ({ id, onChange, checked, label, name, className, disable, ...rest }) => {
    return (
        <div className={util.joinClasses('radioButton', className)}>
            <input
                id={id}
                onChange={onChange}
                type={'radio'}
                checked={checked}
                name={name}
                disabled={disable}
                {...rest}
            />
            <label htmlFor={id} className={`${disable && 'disable'}`}>
                {label}
            </label>
        </div>
    )
}

Radio.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
}

export default memo(Radio)
